import 'react';
import { useTheme, jsx } from '@emotion/react';
import '@babel/runtime/helpers/extends';
import '@babel/runtime/helpers/objectWithoutProperties';
import '../../constants/breakpoints/index.js';
import '../../constants/grid/index.js';
import '../../constants/mediaQueries/index.js';
import '../../constants/boxShadows/primary.js';
import '../../constants/boxShadows/secondary.js';
import ChevronIcon from '../../icons/icons/chevronIcon.js';
import Style from './style.js';

var Dropdown = _ref => {
  var {
    borderRadius,
    id,
    onChange,
    onDropdownContainerFocus,
    options,
    textAlign = 'left',
    value,
    ariaLabel
  } = _ref;
  var theme = useTheme();
  var touchSupported = ('ontouchstart' in document.documentElement);

  var onSelectChange = event => {
    var {
      target
    } = event;
    var {
      selectedIndex,
      selectedOptions
    } = target;
    var selectedOption = options[selectedIndex];

    if (selectedOptions.length) {
      onChange(selectedOption);
    }
  };

  var handleOnDropdownContainerFocus = event => {
    if (onDropdownContainerFocus) {
      onDropdownContainerFocus(event);
    }
  };

  return jsx(Style.DropdownContainer, {
    textAlign: textAlign
  }, jsx("select", {
    css: Style.dropdownInputStyle({
      borderRadius: borderRadius !== null && borderRadius !== void 0 ? borderRadius : theme.BORDER_RADIUS.small,
      shouldBeFullyRounded: true,
      textAlign,
      theme
    }),
    id: id,
    value: value !== null && value !== void 0 ? value : '',
    "aria-label": ariaLabel,
    onChange: onSelectChange,
    onFocus: handleOnDropdownContainerFocus
  }, options.map((option, index) => {
    var _option$value;

    var isDisabled = option.disabled;
    /*
     * We use touchSupported to prevent setting the default value to disabled
     */

    if (option.value === value && touchSupported) {
      isDisabled = false;
    }

    return jsx("option", {
      key: (_option$value = option.value) !== null && _option$value !== void 0 ? _option$value : "undefined-".concat(index),
      value: option.value,
      disabled: isDisabled
    }, option.label);
  })), jsx(Style.IconContainer, null, jsx(ChevronIcon, {
    width: 15,
    height: 15
  })));
};

export { Dropdown };
